import styles from '@/assets/css/main.scss';
import 'vue-good-table/dist/vue-good-table.css';
import ApiPlugin from '@/plugins/api';
import GlobalSpinnerPlugin from '@/plugins/globalSpinner';
import NotificationPlugin from '@/plugins/notification';
import TokenStoragePlugin from '@/plugins/tokenStorage';
import Vue from 'vue';
import contenteditable from 'vue-contenteditable';
import VueGoodTablePlugin from 'vue-good-table';
import VModal from 'vue-js-modal/dist/index.nocss.js';
import 'vue-js-modal/dist/styles.css';
import '@/filters';
import vSelect from 'vue-select';
import App from './App.vue';
import router from './router';
import 'vue-toastification/dist/index.css';

vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: createElement => createElement('span'),
  },
});

Vue.component('v-select', vSelect);
Vue.use(VModal);
Vue.use(styles);
Vue.use(contenteditable);
Vue.use(VueGoodTablePlugin);
Vue.use(TokenStoragePlugin);
Vue.use(NotificationPlugin);
Vue.use(GlobalSpinnerPlugin);
Vue.use(ApiPlugin, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  mock: process.env.VUE_APP_MOCK_API === 'true',
  router: router,
});

// TODO: find better way.
Vue.prototype.$reload = () => {
  window.location.reload();
};

Vue.config.productionTip = process.env.NODE_ENV !== 'production';

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
